module.exports = __webpack_public_path__ + "img/pet-medicine.09a6e361.svg";